export default __webpack_public_path__ + "static/media/picture.5cd4f0bb.jpeg";